import {
  Directive,
  ElementRef,
  EventEmitter,
  Host,
  HostListener,
  Optional,
  Output,
} from '@angular/core';
import { FormControlState, NgrxFormControlDirective } from 'ngrx-forms';

@Directive({
  selector: '[mdTrackCaretPosition]',
})
export class TrackCaretPositionDirective {
  @Output() caretPositionChange = new EventEmitter<{
    controlKey: string;
    caretPosition: number;
    element: HTMLInputElement | HTMLTextAreaElement;
  }>();

  constructor(
    private el: ElementRef<HTMLInputElement | HTMLTextAreaElement>,
    @Optional() @Host() private ngrxControl: NgrxFormControlDirective<any>,
  ) {}

  @HostListener('input')
  @HostListener('click')
  @HostListener('keyup')
  onCaretEvent() {
    if (!this.ngrxControl) {
      return;
    }

    const element = this.el.nativeElement;
    const caretPosition = element.selectionStart ?? 0;
    const controlKey = (this.ngrxControl.state as FormControlState<any>).id;

    this.caretPositionChange.emit({
      controlKey,
      caretPosition,
      element,
    });
  }
}
